import React, { useCallback, useState } from 'react';

import Button from '../../common/Button/Button';
import CardView from '../../common/CardView/CardView';
import Label from '../../common/Labels/Label';
import ModalOverlay from '../../common/ModalOverlay/ModalOverlay';

import EdgeLocationDropdownButton from './EdgeLocationDropdownButton/EdgeLocationDropdownButton';
import { EdgeLocationFilterPanel } from './EdgeLocationFilterPanel/EdgeLocationFilterPanel';
import { usePipelineEdgeData } from '../../VersionHistoryTimeline/PublishPipelineContext';

export const EdgeLocationFilter = ({ locations = [], selectedLocations = [], setSelectedLocations = () => {} }) => {
  const [showFilter, setShowFilter] = useState(false);

  const clearFilter = useCallback(() => setSelectedLocations([]), [setSelectedLocations])
  const applyFilter = useCallback((newSelectedLocations) => {
    if (!newSelectedLocations?.length) {
      setSelectedLocations([])
    } else {
      setSelectedLocations(newSelectedLocations)
    }
    setShowFilter(false);
  }, [setSelectedLocations])
  return (
    <>
      <div className="flex justify-between items-center">
        <EdgeLocationDropdownButton
          locations={selectedLocations}
          totalNumberOfEdges={locations?.length || 0}
          onClick={() => setShowFilter(true)}
        />
        {
          selectedLocations.length > 0 && (
            <div className="ml-2 flex justify-between items-center">
              <Button className="flex justify-between items-center" variant="circle_close" onClick={clearFilter}>
                <Label className="ml-2" color="white" size="sm" bold>Clear filter</Label>
              </Button>
            </div>
          )
        }
      </div>
      {
        showFilter && (
          <ModalOverlay
            animationKey="edge-filter-modal"
            onModalToggle={setShowFilter}
            active={showFilter}
            useScrollLock={false}
          >
            <CardView className="w-filter-modal" disableFullHeight>
              <EdgeLocationFilterPanel
                edgeLocations={locations}
                selectedEdgeLocations={selectedLocations}
                onSubmit={applyFilter}
                onCancel={() => setShowFilter(false)}
              />
            </CardView>
          </ModalOverlay>
        )
      }
    </>
  )
}

export const ContextualEdgeLocationFilter = () => {
  const { listOfEdgesForPipelines, selectedEdgeLocations, setSelectedEdgeLocations } = usePipelineEdgeData();
  return (
    <EdgeLocationFilter
      locations={listOfEdgesForPipelines}
      selectedLocations={selectedEdgeLocations}
      setSelectedLocations={setSelectedEdgeLocations}
    />
  )
}

export default ContextualEdgeLocationFilter;
